var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1499 3.13445H6.10882C3.7501 3.13445 3.0751 1.13447 3.0751 1.13447L2.82135 0.390732C2.76011 0.234484 2.60386 0.128235 2.43261 0.128235H0.420131C0.125134 0.128235 -0.0798635 0.428232 0.0301353 0.703229L0.835127 3.13445L3.88759 12.3369C3.94634 12.5081 4.10634 12.6243 4.28759 12.6243H14.81L14.1937 15.0718H4.71008L4.71258 15.0756C4.69133 15.0756 4.67133 15.0718 4.65008 15.0718C3.3251 15.0718 2.25011 16.1468 2.25011 17.4718C2.25011 18.7968 3.3251 19.8718 4.65008 19.8718C5.88757 19.8718 6.90631 18.9343 7.03756 17.7318L13.975 17.8268C14.125 18.9793 15.1125 19.8718 16.3087 19.8718C17.6087 19.8718 18.6649 18.8168 18.6649 17.5155C18.6649 16.4331 17.9349 15.5243 16.94 15.2481L19.9687 4.20819C20.1187 3.66695 19.7112 3.13445 19.1499 3.13445Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.c268b9b31dc131b500c9d65fd25b0346.svg";
export { ForwardRef as ReactComponent };